import { createSlice } from '@reduxjs/toolkit';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';
import { EventHelperInterface } from '../types';

export default createSlice({
  name: REDUX_STORE_SLICES.EVENT_HELPER,
  initialState: {
    event: {
      type: '',
      payload: null,
    },
  },
  reducers: {
    setEvent: (state, action) => {
      state.event = action.payload;
    },
    resetEvent: (state) => {
      state.event = {
        type: '',
        payload: null,
      };
    },
  },
});

export const eventHelperProps = (state: EventHelperInterface) => state;
